// extracted by mini-css-extract-plugin
module.exports = {"Root":"styles_Root__1DQSB","Title":"styles_Title__1vWYS","Icon":"styles_Icon__2su4I"};